import { NavLink } from "react-router-dom";

const _NAV_LINKS = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/audit", label: "Audit log" },
];

/**
 * Admin sub-navigation — tab-style links using the ui-kit Tabs vocabulary
 * (.tabs-list / .tab-btn). Sits at the top of each admin page.
 */
export function AdminNav() {
  return (
    <nav className="tabs-list" style={{ marginBottom: 24 }} aria-label="Admin navigation">
      {_NAV_LINKS.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `tab-btn${isActive ? " tab-btn--admin-active" : ""}`
          }
          aria-selected={undefined}
          style={({ isActive }) =>
            isActive
              ? { color: "var(--accent-strong)", fontWeight: 600 }
              : { color: "var(--ink-3)", fontWeight: 500 }
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
